import Swal from 'sweetalert2';

/**
 * Configuración de colores para SweetAlert2
 */
const colors = {
  primary: '#3085d6',
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  info: '#3085d6',
};

/**
 * Muestra un mensaje de éxito
 */
export const showSuccessAlert = async (
  title: string,
  text?: string,
  options?: {
    timer?: number;
    showConfirmButton?: boolean;
  }
) => {
  return await Swal.fire({
    title,
    text,
    icon: 'success',
    confirmButtonColor: colors.success,
    timer: options?.timer ?? 2000,
    timerProgressBar: true,
    showConfirmButton: options?.showConfirmButton ?? true,
  });
};

/**
 * Muestra un mensaje de error
 */
export const showErrorAlert = async (
  title: string,
  text?: string
) => {
  return await Swal.fire({
    title,
    text,
    icon: 'error',
    confirmButtonColor: colors.error,
  });
};

/**
 * Muestra un mensaje de advertencia
 */
export const showWarningAlert = async (
  title: string,
  text?: string
) => {
  return await Swal.fire({
    title,
    text,
    icon: 'warning',
    confirmButtonColor: colors.warning,
  });
};

/**
 * Muestra un mensaje de información
 */
export const showInfoAlert = async (
  title: string,
  text?: string
) => {
  return await Swal.fire({
    title,
    text,
    icon: 'info',
    confirmButtonColor: colors.info,
  });
};

/**
 * Muestra un diálogo de confirmación
 */
export const showConfirmDialog = async (
  title: string,
  text?: string,
  options?: {
    confirmButtonText?: string;
    cancelButtonText?: string;
  }
) => {
  return await Swal.fire({
    title,
    text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: colors.primary,
    cancelButtonColor: colors.error,
    confirmButtonText: options?.confirmButtonText ?? 'Sí, continuar',
    cancelButtonText: options?.cancelButtonText ?? 'Cancelar',
  });
};

/**
 * Muestra un loading spinner
 */
export const showLoadingAlert = (title: string, text?: string) => {
  Swal.fire({
    title,
    text,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

/**
 * Cierra cualquier alert activo
 */
export const closeAlert = () => {
  Swal.close();
};
